/* CASA FACILE / ANDREA — GTM dataLayer events.
   Tracks interaction intent only: not verified calls, leads or orders.
   No user-entered text, phone number, URL query or identifiers are collected. */
(function () {
  'use strict';
  if (window.__aeGrowthTrackingReady) return;
  window.__aeGrowthTrackingReady = true;
  function record(eventName, channel) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      interaction_channel: channel,
      page_path: window.location.pathname,
      source: 'ae_growth_theme'
    });
  }
  document.addEventListener('click', function (event) {
    var origin = event.target;
    if (!origin || typeof origin.closest !== 'function') return;
    var anchor = origin.closest('a[href]');
    if (!anchor) return;
    var href = anchor.getAttribute('href') || '';
    if (/^tel:/i.test(href)) {
      record('ae_phone_click', 'phone');
    } else if (/^(https?:\/\/)?(www\.)?(wa\.me|api\.whatsapp\.com|web\.whatsapp\.com)\b/i.test(href)) {
      record('ae_whatsapp_click', 'whatsapp');
    }
  }, true);
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form')) return;
    var action = form.getAttribute('action') || '';
    if (/(^|\/)contact([?#]|$)/i.test(action)) {
      record('ae_contact_form_attempt', 'form');
    }
  }, true);
}());